<div class="guest-picker">
  @if (selectedRow) {
    <div class="gp-selected-card">
      <tidy-initials-icon [fullName]="selectedRow.name" />
      <div class="gp-result-info">
        <tidy-text [body]="selectedRow.name" />
        @if (selectedRow.contact) {
          <tidy-text [helper]="selectedRow.contact" />
        }
      </div>
      <div class="gp-badge">
        @if (selectedRow.badge.icon) {
          <tidy-image [src]="selectedRow.badge.icon" class="gp-badge-icon" />
        }
        <tidy-text [helper]="selectedRow.badge.label" />
      </div>
      <tidy-text
        [actionBody]="'Change'"
        (action)="clearSelection()"
        class="link gp-change" />
    </div>
  } @else {
    <div class="gp-mode-toggle">
      <div
        class="gp-mode-pill"
        [class.active]="mode === 'search'"
        (click)="switchToSearch()">
        <tidy-image [src]="'assets/svg/search-outline.svg'" class="gp-pill-icon" />
        <tidy-text [body]="'Find Existing'" />
      </div>
      <div
        class="gp-mode-pill"
        [class.active]="mode === 'create'"
        (click)="switchToCreate()">
        <tidy-image [src]="'assets/svg/person-add-outline.svg'" class="gp-pill-icon" />
        <tidy-text [body]="'Add New'" />
      </div>
    </div>

    @if (mode === 'search') {
      <form [formGroup]="searchForm" novalidate action="#">
        <tidy-row class="field-top-padding">
          <tidy-input
            formControlName="search"
            [form]="searchForm.controls.search"
            [label]="label"
            [icon]="'assets/svg/search-outline.svg'" />
        </tidy-row>
      </form>

      @if (isSearching) {
        <div class="gp-results">
          @for (i of skeletonRows; track i) {
            <div class="gp-result-row gp-skeleton">
              <ion-skeleton-text [animated]="true" class="gp-skel-avatar" />
              <div class="gp-skel-lines">
                <ion-skeleton-text [animated]="true" class="gp-skel-line" />
                <ion-skeleton-text [animated]="true" class="gp-skel-line short" />
              </div>
            </div>
          }
        </div>
      } @else if (resultRows.length > 0) {
        <div class="gp-results">
          @for (row of resultRows; track row.guest.id) {
            <div class="gp-result-row" (click)="selectGuest(row)">
              <tidy-initials-icon [fullName]="row.name" />
              <div class="gp-result-info">
                <tidy-text [body]="row.name" />
                @if (row.contact) {
                  <tidy-text [helper]="row.contact" />
                }
              </div>
              <div class="gp-badge">
                @if (row.badge.icon) {
                  <tidy-image [src]="row.badge.icon" class="gp-badge-icon" />
                }
                <tidy-text [helper]="row.badge.label" />
              </div>
            </div>
          }
        </div>
      } @else if (hasSearched) {
        <div class="gp-empty">
          <tidy-image [src]="'assets/svg/person-outline.svg'" class="gp-empty-icon" />
          <tidy-text [helper]="'No guests found.'" />
          <tidy-text
            [actionBody]="('+ Add ' | translate) + (searchQuery || 'them') + (' as a new guest' | translate)"
            (action)="createFromSearch()"
            class="link" />
        </div>
      }
    }

    @if (mode === 'create') {
      <form [formGroup]="newGuestForm" action="#" class="gp-create-form">
        <tidy-row class="field-top-padding">
          <tidy-input
            formControlName="name"
            [form]="newGuestForm.controls.name"
            label="Guest Name"
            [icon]="'assets/svg/person.svg'"
            [submitted]="submitted"
            [errorMessage]="'Please enter the guest name.'" />
        </tidy-row>
        <tidy-row>
          <tidy-input
            formControlName="email"
            [form]="newGuestForm.controls.email"
            [type]="'email'"
            label="Guest Email (optional)"
            [icon]="'assets/svg/mail.svg'"
            [submitted]="submitted"
            [errorMessage]="'Please enter a valid email.'" />
        </tidy-row>
        <tidy-row>
          <tidy-input-international-phone
            formControlName="phone"
            [form]="newGuestForm.controls.phone"
            [label]="'Guest Phone (optional)'"
            [inputMode]="'numeric'"
            [submitted]="submitted"
            [errorMessage]="'Please enter a valid phone.'"
            [icon]="'assets/svg/phone-portrait.svg'"
            [initialMask]="{ mask: '[00000000000000000000000]' }"
            (countryCodeChange)="onCountryCodeChange($event)" />
        </tidy-row>
        <tidy-row>
          <tidy-text [helper]="'A phone number lets you message this guest by SMS.'" />
        </tidy-row>
      </form>
    }
  }

  @if (submitted && !hasValidValue && mode === 'search') {
    <tidy-error-message [text]="'Please add a guest to continue.'" />
  }
</div>
